import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-jumbotron',
  template: '<ng-content></ng-content>',
  styleUrls: ['./jumbotron.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-jumbotron' },
})
export class JumbotronComponent {}
